import React, { PropTypes } from 'react';


class ImageSequenceItem extends React.Component {

  // ==================================================================================
  // CONSTRUCTOR ----------------------------------------------------------------------

  constructor() {
    super();
  }


  // ==================================================================================
  // EVENT INTERFACE ------------------------------------------------------------------

  // handleUpdate();


  // ==================================================================================
  // INTERNAL INTERFACE ---------------------------------------------------------------

  render() {
    var styles = {
      backgroundImage: 'url('+ this.props.src +')',
    };


    return (
      <div className={ 'image-sequence-item' + (this.props.active ? ' active' : '') }
           style={ styles }>
      </div>
    );
  }
}


export default ImageSequenceItem;



/** WEBPACK FOOTER **
 ** ./src/app/components/ui/animation/ImageSequenceItem.jsx
 **/